import _, { isObject } from "lodash";
import { useEffect, useState } from "react";
import moment from "moment";
import { useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";
import { selectCurrentUser } from "src/modules/users/selector";
import { getItemsRequest } from "src/modules/spItems/api";
import Form from "src/components/Form";
import {
  myTasksDepartmentsListName,
  myTasksDependListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
} from "src/api/config/myTasksLists.config";
import {
  myTasksIncidentsQuestionsListName,
  myTasksIncidentsStatusesListName,
  myTasksTypeIncidentsListName,
} from "src/api/config/myTasksInc.config";
import {FlexCol, FlexRow} from "src/utils/flexLayouts";
import {
  incStatus,
  incTypes
} from "src/api/config/systemSwitch";

export function IncidentsFilters({
  onClose,
  searchQuery,
  setFilters,
  setSearchQuery,
  setGegIncidents,
  filters,
  setLocalFilters,
  setFieldsFromExel,
  displayFilters,
  setDisplayFilters,
  filtersParams,
  setFiltersParams,
  setCurrentTypeInc,
  currentTypeInc,
  defaultUserFilter,
  setDefaultUserFilter,
  reRenderFilterSettings,
  userFilterCheck,
  reRenderUserFilter,
  favoriteFilters,
  setFavoriteFilters,
  handleResetAllFilters,
  setIncidentsFilter,
  incidentsFilter,
  setResetFiters,
  resetFilters
}: any) {
  const [defaultValues, setDefaultValues] = useState({});
  const [incQuestions, setIncQuestions] = useState<any>([]);
  const [fields, setFields] = useState<any>([]);
  const [renderInc, setRenderInc] = useState(false);
  const [incKeys, setIncKeys] = useState<any>([]);

  const collections: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
  const departments: any = useAppSelector((state) => selectItems(state, myTasksDepartmentsListName));
  const sectors: any = useAppSelector((state) => selectItems(state, myTasksRegionsListName));
  const statuses: any = useAppSelector((state) => selectItems(state, myTasksIncidentsStatusesListName));
  const typesIncList: any = useAppSelector((state) => selectItems(state, myTasksTypeIncidentsListName));

  const toFormDate = (d: any) => {
    if (!d || typeof d !== "object") return null;
    const startVal = d.start ?? d.startDate;
    const endVal = d.end ?? d.endDate;
    if (!startVal && !endVal) return null;
    return {
      startDate: startVal,
      endDate: endVal,
    };
  };

  const toFormLookup = (value: any, collection: any[]) => {
    if (!Array.isArray(value) || value.length === 0) return value;
    if (typeof value[0] === "object" && value[0] !== null && "id" in value[0]) {
      return value;
    }
    return value
      .map((id: any) => {
        const item = collection?.find((c: any) => c.ID === id);
        return item ? { id: item.ID, name: item.Title } : null;
      })
      .filter(Boolean);
  };

  const lookupCollections: Record<string, any[]> = {
    Location: collections,
    Department: departments,
    Region: sectors,
    Status: statuses,
  };

  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
  });

  const [customLoading, setCustomLoading] = useState(true);
  const [typesInc, setTypesInc] = useState<any>([]);
  const currentUser = useAppSelector((state) => selectCurrentUser(state));

 useEffect(() => {
     if (renderInc) {
       setCustomLoading(true);
       const tempFieldsForm = [...fields];
       for (let i = 0; i < tempFieldsForm.length; i++) {
         if (tempFieldsForm[i]["key"] === "Location") {
           tempFieldsForm[i]["optionsInputs"] = collections.map(
             (collection: any) => {
               return {
                 id: collection.ID,
                 name: collection.Title,
                 disabled: false,
               };
             }
           );
         }
         if (tempFieldsForm[i]["key"] === "Department") {
           tempFieldsForm[i]["optionsInputs"] = departments.map(
             (department: any) => {
               return {
                 id: department.ID,
                 name: department.Title,
                 disabled: false,
               };
             }
           );
         }
         if (tempFieldsForm[i]["key"] === "Region") {
           tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
             return {
               id: sector.ID,
               name: sector.Title,
               disabled: false,
             };
           });
         }
         if (incidentsFilter && incidentsFilter.IncidentOption) {
           if (tempFieldsForm[i]["key"] === "Status") {
             tempFieldsForm[i]["optionsInputs"] = statuses
               .filter(
                 (status: any) =>
                   (incidentsFilter.IncidentOption === "Несоответствие" &&
                     status.ID !== incStatus.finish) ||
                   (incidentsFilter.IncidentOption === "Инцидент" &&
                     status.ID !== incStatus.closed)
               )
               .map((status: any) => {
                 return {
                   id: status.ID,
                   name: status.Title,
                   disabled: false,
                 };
               });
           }
         }
         if (tempFieldsForm[i]["key"] === "TypeIncident") {
           tempFieldsForm[i]["optionsInputs"] =
             typesInc.map((type: any) => type.Title.trim()) || [];
         }
       }
       setFields([...tempFieldsForm]);
       setCustomLoading(false);
     }
   }, [collections, departments, sectors, renderInc, statuses, incidentsFilter]);

useEffect(() => {
    if (renderInc) {
    setCustomLoading(true);
    let filtersDependDocuments: any = {};
    const tempFieldsForm = [...fields];
    Object.keys(dependenceFields).map((key) => {
        for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === key) {
            tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i][
            "optionsInputs"
            ].map((option: any) => {
            return {
                id: option.id,
                name: option.name,
                disabled: false,
            };
            });
        }
        }
    });
    Object.keys(dependenceFields).map((key) => {
        if (dependenceFields[key] && dependenceFields[key].length > 0) {
        filtersDependDocuments[key] = dependenceFields[key].map(
            (item: any) => item.id
        );
        }
    });
    if (Object.keys(filtersDependDocuments).length === 0) {
        setFields([...tempFieldsForm]);
        setCustomLoading(false);
    } else {
        if (Object.keys(filtersDependDocuments).length > 0) {
        //Устанавливаем зависимости в фильтрах
        getItemsRequest({
            listName: myTasksDependListName,
            filters: filtersDependDocuments,
            filtersType: "or",
        }).then((results) => {
            const dependDocuments = [...results.items];
            const collectionIds = _.uniqWith(
            dependDocuments.map((item: any) => item.Location.get_lookupId()),
            _.isEqual
            );
            const departmentIds = _.uniqWith(
            dependDocuments.map((item: any) =>
                item.Departament.get_lookupId()
            ),
            _.isEqual
            );
            const sectorIds = _.uniqWith(
            dependDocuments.map((item: any) => item.Region.get_lookupId()),
            _.isEqual
            );
            for (let i = 0; i < tempFieldsForm.length; i++) {
            if (tempFieldsForm[i]["key"] === "Location") {
                if (
                !filtersDependDocuments["Location"] ||
                Object.keys(filtersDependDocuments).length > 1
                ) {
                tempFieldsForm[i]["optionsInputs"] = collections.map(
                    (collection: any) => {
                    return {
                        id: collection.ID,
                        name: collection.Title,
                        disabled: false, // collectionIds.indexOf(collection.ID) === -1,
                        hide: collectionIds.indexOf(collection.ID) === -1,
                    };
                    }
                );
                }
            }
            if (tempFieldsForm[i]["key"] === "Department") {
                if (
                !filtersDependDocuments["Department"] ||
                Object.keys(filtersDependDocuments).length > 1
                ) {
                tempFieldsForm[i]["optionsInputs"] = departments.map(
                    (department: any) => {
                    return {
                        id: department.ID,
                        name: department.Title,
                        disabled: false, // departmentIds.indexOf(department.ID) === -1,
                        hide: departmentIds.indexOf(department.ID) === -1,
                    };
                    }
                );
                }
            }
            if (tempFieldsForm[i]["key"] === "Region") {
                if (
                !filtersDependDocuments["Region"] ||
                Object.keys(filtersDependDocuments).length > 1
                ) {
                tempFieldsForm[i]["optionsInputs"] = sectors.map(
                    (sector: any) => {
                    return {
                        id: sector.ID,
                        name: sector.Title,
                        disabled: false, //sectorIds.indexOf(sector.ID) === -1,
                        hide: sectorIds.indexOf(sector.ID) === -1,
                    };
                    }
                );
                }
            }
            }
            setFields([...tempFieldsForm]);
            setCustomLoading(false);
        });
        }
    }
    }
}, [dependenceFields, renderInc]);

  useEffect(() => {
    if (incQuestions.length > 0) {
      setFieldsFromExel([...incQuestions]);
      setFields(_.uniqBy(incQuestions, "key"));
      setRenderInc(true);
      setCustomLoading(false);
    }
  }, [incQuestions]);

  useEffect(() => {
    if (typesIncList.length > 0) {
      setTypesInc(
        typesIncList.filter((type: any) => type.ID !== incTypes.security)
      );
    }
  }, [typesIncList]);

  useEffect(() => {
    if (currentTypeInc && typesInc.length > 0) {
      const tempCurrentTypeInc = currentTypeInc.split("_")[0];
      setCustomLoading(true);
      setRenderInc(false);
      const idCurrentTypeInc = typesInc.filter(
        (type: any) => type.Title === tempCurrentTypeInc
      )[0]["ID"];
      getItemsRequest({
        listName: myTasksIncidentsQuestionsListName,
        filters: { TypeIncident: idCurrentTypeInc },
        sortOrder: { name: "Order0", asc: true },
      }).then((results) => {
        const tempIncQuestions = [...results.items];
        let incFieldsForm: any = [];
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "dateRange",
              require: false,
              key: "DateIncidents",
              title: "Дата регистрации несоответсвия/инцидента",
              placeholder: "дд.мм.гггг",
              isFilter: true,
              condition: null,
              width: "w-full",
            },
            {
              type: "dateRange",
              require: false,
              key: "DateIncidents2",
              title: "Дата несоответствия/инцидента",
              placeholder: "дд.мм.гггг",
              isFilter: true,
              condition: null,
              width: "w-full",
            },
            {
              type: "timeRange",
              require: false,
              key: "TimeIncident",
              isFilter: true,
              title: "Время несоответствия/инцидента",
              placeholder: "чч:мм",
              condition: null,
              width: "w-full",
            },
            {
              type: "radio",
              require: false,
              isFilter: true,
              title: "Тип несоответствия/инцидента",
              key: "TypeIncident",
              condition: null,
              width: "w-full",
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key === "IncidentOption" || item.Key === "QAIncidentType") {
            incFieldsForm = [
              ...incFieldsForm,
              {
                type: item.TypeQuestion,
                require: false,
                noticeAnswers:
                  (item.NoticeAnswers &&
                    JSON.parse(item.NoticeAnswers).filter(
                      (notice: any) => notice.TypeIncident === tempCurrentTypeInc
                    ).length > 0 &&
                    JSON.parse(item.NoticeAnswers).filter(
                      (notice: any) => notice.TypeIncident === tempCurrentTypeInc
                    )[0]["Notice"]) ||
                  null,
                notice: item.Notice,
                noticeIcon: (item.Notice && true) || false,
                key: item.Key,
                isFilter: true,
                title: item.Title,
                hide: item.DefaultHide,
                width: "w-full",
                optionsInputs:
                  (item.Options &&
                    item.Options.split(";").map((option) => option.trim())) ||
                  [],
                condition: item.Condition && JSON.parse(item.Condition),
              },
            ];
          }
        });
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "peoplePicker",
              require: false,
              single: true,
              key: "ResponsibleEmail",
              title: "ФИО инициатора",
              isFilter: true,
              condition: null,
              placeholder: "Введите имя или фамилию",
              width: "w-full",
            },

            {
              type: "checkbox",
              require: false,
              key: "Location",
              isFilter: true,
              title: "Локация, где произошло несоответствие/инцидент",
              condition: null,
              width: "w-full",
            },
            {
              type: "checkbox",
              require: false,
              key: "Department",
              isFilter: true,
              title: "Отдел, где произошло несоответствие/инцидент",
              condition: null,
              width: "w-full",
            },
            {
              type: "checkbox",
              require: false,
              key: "Region",
              isFilter: true,
              title: "Участок, где произошло несоответствие/инцидент",
              condition: null,
              width: "w-full",
            },
            {
              type: "checkbox",
              require: false,
              key: "Status",
              isFilter: true,
              title: "Статус",
              width: "w-full",
            },
            {
              type: "checkbox",
              require: false,
              key: "StatusActions",
              isFilter: true,
              title: "Статус действий",
              width: "w-full",
              optionsInputs: [
                {
                  id: 1,
                  name: "Нет действий",
                },
                {
                  id: 2,
                  name: "В процессе",
                },
                {
                  id: 3,
                  name: "Просрочено",
                },
                {
                  id: 4,
                  name: "Отменено",
                },
                {
                  id: 5,
                  name: "Закрыто",
                },
              ],
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key !== "IncidentOption" && item.Key !== "QAIncidentType") {
            if (item.TypeQuestion === "select") {
              if (
                item.Key === "SafeIncRiskCategory" ||
                item.Key === "SafeNRiskCategory" ||
                item.Key === "SafeIncClassification"
              ) {
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: "radio",
                    require: false,
                    key: item.Key,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: item.Title,
                    isFilter: true,
                    hide: item.DefaultHide,
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                    optionsInputs:
                      item.Options &&
                      item.Options.split(";").map((option) => option.trim()),
                  },
                ];
              } else {
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: "checkbox",
                    require: false,
                    key: item.Key,
                    title: item.Title,
                    isFilter: true,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    hide: item.DefaultHide,
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                    optionsInputs:
                      item.Options &&
                      item.Options.split(";").map((value: any) => {
                        return {
                          id: value,
                          name: value,
                          disabled: false,
                        };
                      }),
                  },
                ];
              }
            } else if (
              item.TypeQuestion === "radio" ||
              item.TypeQuestion === "checkbox"
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: false,
                  key: item.Key,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  title: item.Title,
                  hide: item.DefaultHide,
                  width: "w-full",
                  isFilter: true,
                  condition: item.Condition && JSON.parse(item.Condition),
                  optionsInputs:
                    (item.TypeQuestion === "checkbox" &&
                      item.Options &&
                      item.Options.split(";").map((value: any) => {
                        return {
                          id: value,
                          name: value,
                          disabled: false,
                        };
                      })) ||
                    (item.Options &&
                      item.Options.split(";").map((option) => option.trim())) ||
                    [],
                },
              ];
            } else if (item.TypeQuestion === "repeater") {
              incFieldsForm = [
                ...incFieldsForm,
                ...[
                  {
                    type: "checkbox_search",
                    require: false,
                    hide: item.DefaultHide,
                    title: "SAP № технического места",
                    key: "Equipments_SAP",
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    searchApiField: "SAP",
                    isFilter: true,
                    placeholder: "Введите SAP",
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                  },
                  {
                    type: "checkbox_search",
                    require: false,
                    isFilter: true,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: "Название оборудования",
                    searchApiField: "Title",
                    key: "Equipments_Title",
                    placeholder: "Введите название",
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                  },
                  {
                    type: "checkbox_search",
                    require: false,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: "Производитель оборудования",
                    key: "Equipments_Manufacturer",
                    searchApiField: "Manufacturer",
                    isFilter: true,
                    placeholder: "Введите производителя",
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                  },
                  {
                    type: "checkbox_search",
                    require: false,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: "Модель оборудования",
                    key: "Equipments_Model",
                    searchApiField: "Model",
                    isFilter: true,
                    placeholder: "Введите модель",
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                  },
                  {
                    type: "checkbox_search",
                    require: false,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: "Тип оборудования",
                    key: "Equipments_TypeEquipment",
                    searchApiField: "TypeEquipment",
                    isFilter: true,
                    placeholder: "Введите тип",
                    width: "w-full",
                    condition: item.Condition && JSON.parse(item.Condition),
                  },
                ],
              ];
            } else if (
              item.Key.indexOf("SafeNTypeSIF") !== -1 ||
              item.Key.indexOf("SafeIncTypeSIF") !== -1
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: "checkbox",
                  require: false,
                  key: item.Key,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  title: item.Title,
                  hide: item.DefaultHide,
                  width: "w-full",
                  isFilter: true,
                  condition: item.Condition && JSON.parse(item.Condition),
                  optionsInputs: [
                    {
                      id: "Not SIF",
                      name: "Not SIF",
                      disabled: false,
                    },
                    {
                      id: "SIF Precursor",
                      name: "SIF Precursor",
                      disabled: false,
                    },
                    {
                      id: "SIF Potential",
                      name: "SIF Potential",
                      disabled: false,
                    },
                    {
                      id: "SIF Actual",
                      name: "SIF Actual",
                      disabled: false,
                    },
                  ],
                },
              ];
            } else if (item.TypeQuestion === "number") {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: "numberRange",
                  require: false,
                  key: item.Key,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  title: item.Title,
                  isFilter: true,
                  hide: item.DefaultHide,
                  width: "w-full",
                  condition: item.Condition && JSON.parse(item.Condition),
                },
              ];
            } else if (
              item.TypeQuestion === "textArea" ||
              item.TypeQuestion === "input"
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: false,
                  key: item.Key,
                  title: item.Title,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  disabled: item.Disabled,
                  placeholder: "Введите значение",
                  hide: true,
                  width: item.Width,
                  condition: null,
                  default: item.Options,
                },
              ];
            }
          }
        });
        incFieldsForm = [
          ...incFieldsForm,
          {
            type: "dateRange",
            require: false,
            key: "ClosedDate",
            title: "Срок на закрытие инцидента/несоответствия",
            placeholder: "дд.мм.гггг",
            isFilter: true,
            condition: null,
            width: "w-full",
          },
        ];
        setIncQuestions(_.uniqBy(incFieldsForm, "key"));
      });
    }
  }, [currentTypeInc, typesInc]);

  useEffect(() => {
    if (renderInc && incidentsFilter && Object.keys(incidentsFilter).length > 0) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        const field = tempFieldsForm[i];
        if (field.condition) {
          let conditionObj: any = {};
          Object.keys(field.condition).map((key: string) => {
            if (Array.isArray(incidentsFilter[key])) {
              if (
                incidentsFilter[key].some(
                  (item) => item.name === field.condition[key]
                )
              ) {
                conditionObj[key] = true;
              }
            } else if (typeof incidentsFilter[key] === "object") {
              if (incidentsFilter[key] && incidentsFilter[key]["name"] && incidentsFilter[key]["name"] === field.condition[key]) {
                conditionObj[key] = true;
              }
            } else {
              if (incidentsFilter[key] === field.condition[key]) {
                conditionObj[key] = true;
              }
            }
          });
          if (
            Object.keys(field.condition).length ===
            Object.keys(conditionObj).length
          ) {
            tempFieldsForm[i]["hide"] = false;
          } else {
            tempFieldsForm[i]["hide"] = true;
          }
        }
      }
      let tempKeys: any = [];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        const field = tempFieldsForm[i];
        if (
          !field.hide &&
          (field.condition ||
            field.key === "IncidentOption" ||
            field.key === "QAIncidentType")
        ) {
          tempKeys = [...tempKeys, field.key];
        }
      }
      setFields([...tempFieldsForm]);
      setIncKeys([...tempKeys]);
    }
  }, [incidentsFilter, renderInc]);

  useEffect(() => {
    if (renderInc && collections.length > 0) {

    // if (incidentsFilter && Object.keys(incidentsFilter).length > 0) {
    //   setDefaultValues(incidentsFilter);
    //   return;
    // }

      let defaultObj: any = {};
      const today = moment();
      const isMonday = today.isoWeekday() === 1;
      if (Object.keys(filtersParams).length > 0) {
        Object.keys(filtersParams).forEach(key => {
          if (key === "TypeIncident") {
            defaultObj[key] = currentTypeInc.split("_")[0];
          } else if (filtersParams[key]) {
            defaultObj[key] = lookupCollections[key]
              ? toFormLookup(filtersParams[key], lookupCollections[key])
              : filtersParams[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['DateIncidents'] = toFormDate(filtersParams['DateIncidents']) || (!defaultUserFilter && toFormDate(incidentsFilter?.['DateIncidents'])) || {
          startDate: isMonday ? moment().subtract(1, "weeks").startOf("isoWeek").format('YYYY-MM-DDT00:00:00') : moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
          endDate: isMonday ? moment().subtract(1, "weeks").endOf("isoWeek").format('YYYY-MM-DDT23:59:59') : moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
        };
        defaultObj['DateIncidents2'] = toFormDate(filtersParams['DateIncidents2']) || (!defaultUserFilter && toFormDate(incidentsFilter?.['DateIncidents2'])) || null;
        defaultObj['TimeIncident'] = filtersParams['TimeIncident'] || (!defaultUserFilter && incidentsFilter?.['TimeIncident']) || null;
        defaultObj['ClosedDate'] = toFormDate(filtersParams['ClosedDate']) || (!defaultUserFilter && toFormDate(incidentsFilter?.['ClosedDate'])) || null;
        if (!_.isEqual(defaultValues, defaultObj)) {
          setDefaultValues(defaultObj);
        }
      } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).length > 0) {
        const parsedDefault = JSON.parse(defaultUserFilter.MTFullFilters);
        Object.keys(parsedDefault).forEach(key => {
          if (key === "TypeIncident") {
            defaultObj[key] = currentTypeInc.split("_")[0];
          } else if (parsedDefault[key]) {
            defaultObj[key] = lookupCollections[key]
              ? toFormLookup(parsedDefault[key], lookupCollections[key])
              : parsedDefault[key];
          } else {
            defaultObj[key] = null;
          }
        });
        defaultObj['DateIncidents'] = toFormDate(parsedDefault['DateIncidents']) || {
          startDate: isMonday ? moment().subtract(1, "weeks").startOf("isoWeek").format('YYYY-MM-DDT00:00:00') : moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
          endDate: isMonday ? moment().subtract(1, "weeks").endOf("isoWeek").format('YYYY-MM-DDT23:59:59') : moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
        };
        defaultObj['DateIncidents2'] = toFormDate(parsedDefault['DateIncidents2']) || null;
        defaultObj['TimeIncident'] = parsedDefault['TimeIncident'] || null;
        defaultObj['ClosedDate'] = toFormDate(parsedDefault['ClosedDate']) || null;
        if (!_.isEqual(defaultValues, defaultObj)) {
          setDefaultValues(defaultObj);
        }
      } else {
        let defaultLocationsIds: number[] = [];
        if (Object.keys(currentUser).length > 0 && (currentUser.isLocationAdminMyTasks || currentUser.isLocationEditorMyTasks)) {
          if (Array.isArray(currentUser.isLocationAdminMyTasks) && currentUser.isLocationAdminMyTasks.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationAdminMyTasks];
          }
          if (Array.isArray(currentUser.isLocationEditorMyTasks) && currentUser.isLocationEditorMyTasks.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationEditorMyTasks];
          }
        }
        let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
        setDependenceFields({
          Location: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
            return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
          }) || null,
          Department: null,
          Region: null,
        });
        fields.map((field: any) => {
          if (field.key === "DateIncidents" || field.key === "DateIncidents2") {
            defaultObj[field.key] =
              toFormDate(incidentsFilter?.[field.key]) ||
              (field.key === "DateIncidents" && {
                startDate: isMonday ? moment().subtract(1, "weeks").startOf("isoWeek").format('YYYY-MM-DDT00:00:00') : moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
                endDate: isMonday ? moment().subtract(1, "weeks").endOf("isoWeek").format('YYYY-MM-DDT23:59:59') : moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
              }) ||
              null;
          } else if (field.key === "IncidentOption") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["IncidentOption"]) ||
              "Несоответствие";
          } else if (field.key === "TypeIncident") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["TypeIncident"]) ||
              currentTypeInc.split("_")[0];
          } else if (field.key === "ResponsibleEmail") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["ResponsibleEmail"]) || null;
          } else if (field.key === "TimeIncident") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["TimeIncident"]) || null;
          } else if (field.key === "Location") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["Location"]) || (unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
                return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
              })) || null;
          } else if (field.key === "Department") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["Department"]) || null;
          } else if (field.key === "Region") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["Region"]) || null;
          } else if (field.key === "Status") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["Status"]) || null;
          } else if (field.key === "StatusActions") {
            defaultObj[field.key] =
              (incidentsFilter && incidentsFilter["StatusActions"]) || null;
          } else if (field.key === "ClosedDate") {
            defaultObj[field.key] = toFormDate(incidentsFilter?.[field.key]) || null;
          } else {
            defaultObj[field.key] = null;
          }
        });
        if (!_.isEqual(defaultValues, defaultObj)) {
          setDefaultValues(defaultObj);
        }
      }

    }
  }, [renderInc, resetFilters, collections, departments, sectors, statuses, reRenderUserFilter]);

  useEffect(() => {
    if (renderInc) {
      if (searchQuery) {
        setFilters((prevState: any) => {
          return { ...prevState, Description: `${searchQuery}*` };
        });
        setDisplayFilters((prevState: any) => {
          return { ...prevState, Description: `Поиск: ${searchQuery}*` };
        });
        setGegIncidents(false);
      } else if (
        !searchQuery &&
        Object.keys(filters).length > 0 &&
        filters["Description"]
      ) {
        setFilters((prevState: any) => {
          if (prevState && prevState.hasOwnProperty("Description")) {
            delete prevState["Description"];
            return { ...prevState };
          } else {
            return prevState;
          }
        });
        setDisplayFilters((prevState: any) => {
          if (prevState && prevState.hasOwnProperty("Description")) {
            delete prevState["Description"];
            return { ...prevState };
          } else {
            return prevState;
          }
        });
        setGegIncidents(false);
      }
    }
  }, [searchQuery, renderInc]);

  useEffect(() => {
    if (incKeys.length > 0 && incidentsFilter && Object.keys(incidentsFilter).length > 0) {
      const existsFiltersIncidents: any = {};
      Object.keys(incidentsFilter).map((key) => {
        if (incidentsFilter[key]) {
          if (Array.isArray(incidentsFilter[key])) {
            if (incidentsFilter[key].length > 0) {
              existsFiltersIncidents[key] = incidentsFilter[key];
            }
          } else if (isObject(incidentsFilter[key])) {
            if (Object.keys(incidentsFilter[key]).length > 0) {
              existsFiltersIncidents[key] = incidentsFilter[key];
            }
          } else {
            existsFiltersIncidents[key] = incidentsFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      const tempDisplayFilters: any = {};
      let tempIncidentsQuestions: any = [];
      let tempLocalIncidentsQuestions: any = {};
      if (Object.keys(existsFiltersIncidents).length > 0) {
        Object.keys(existsFiltersIncidents).map((key) => {
          if (
            incKeys.some((incKey: string) => incKey === key) &&
            key !== "QAIncidentList" &&
            key !== "QAIncidentListBlock" &&
            key !== "MIncDowntime" &&
            key !== "MIncEmergencyPurchaseCost" &&
            key !== "MIncQuantityOfLostProduct"
          ) {
            if (Array.isArray(existsFiltersIncidents[key])) {
              if (existsFiltersIncidents[key].length > 0) {
                if (
                  existsFiltersIncidents[key].some(
                    (item) =>
                      typeof item === "object" && item.hasOwnProperty("name")
                  )
                ) {
                  existsFiltersIncidents[key].sort((a: any, b: any) => {
                    return a.name.localeCompare(b.name);
                  });
                } else {
                  existsFiltersIncidents[key].sort((a: any, b: any) => {
                    return a.localeCompare(b.name);
                  });
                }
                tempLocalIncidentsQuestions = {
                  ...tempLocalIncidentsQuestions,
                  ...{ [key]: existsFiltersIncidents[key] },
                };
                tempDisplayFilters[key] = existsFiltersIncidents[key].map((item => item.name || item));
              }
            } else {
              if (
                key === "SafeNRiskCategory" ||
                key === "SafeIncRiskCategory" ||
                key === "SafeIncClassification"
              ) {
                tempIncidentsQuestions = [
                  ...tempIncidentsQuestions,
                  `"${key}":{"id":"${existsFiltersIncidents[key]}","name":"${existsFiltersIncidents[key]}"}`,
                ];
                tempDisplayFilters[key] = existsFiltersIncidents[key];
              } else {
                tempIncidentsQuestions = [
                  ...tempIncidentsQuestions,
                  `"${key}":${`"${existsFiltersIncidents[key]}"`}`,
                ];
                tempDisplayFilters[key] = existsFiltersIncidents[key];
              }
            }
          } else if (
            key === "ClosedDate" ||
            key === "DateIncidents" ||
            key === "DateIncidents2"
          ) {
            if (
              moment(existsFiltersIncidents[key].startDate).isValid() &&
              moment(existsFiltersIncidents[key].endDate).isValid()
            ) {
              tempFilters[key] = {
                start: moment(existsFiltersIncidents[key].startDate).startOf('day').format('YYYY-MM-DDT00:00:00'),
                end: moment(existsFiltersIncidents[key].endDate).endOf('day').format('YYYY-MM-DDT23:59:59'),
              };
              tempDisplayFilters[key] = `от ${moment(existsFiltersIncidents[key].startDate).format('DD.MM.YYYY')} до ${moment(existsFiltersIncidents[key].endDate).format('DD.MM.YYYY')}`;
            }
          } else if (key === "ResponsibleEmail") {
            if (
              Array.isArray(existsFiltersIncidents[key]) &&
              existsFiltersIncidents[key].length > 0 &&
              existsFiltersIncidents[key][0]["value"]
            ) {
              tempFilters[key] = `${existsFiltersIncidents[key][0]["value"]}*`;
              tempDisplayFilters[key] = existsFiltersIncidents[key][0]["label"];
            }
          } else if (
            key === "TimeIncident" ||
            key === "QAIncidentList" ||
            key === "MIncDowntime" ||
            key === "MIncEmergencyPurchaseCost" ||
            key === "MIncQuantityOfLostProduct" ||
            key === "StatusActions" ||
            key === "QAIncidentListBlock"
          ) {
            tempLocalIncidentsQuestions = {
              ...tempLocalIncidentsQuestions,
              ...{ [key]: existsFiltersIncidents[key] },
            };
            tempDisplayFilters[key] = existsFiltersIncidents[key];
          } else if (key === "TypeIncident") {
            const idCurrentTypeInc = typesInc.filter(
              (type: any) => type.Title === currentTypeInc.split("_")[0]
            )[0]?.["ID"];
            if (idCurrentTypeInc) {
              tempFilters[key] = idCurrentTypeInc;
              tempDisplayFilters[key] = currentTypeInc.split("_")[0];
            }
          } else if (
            key === "Location" ||
            key === "Department" ||
            key === "Region" ||
            key === "Status"
          ) {
            if (Array.isArray(existsFiltersIncidents[key]) && existsFiltersIncidents[key].length > 0) {
              tempFilters[key] = existsFiltersIncidents[key].map(
                (item: any) => item.id
              ).filter((id: any) => id);
              tempDisplayFilters[key] = existsFiltersIncidents[key].map((item: any) => item.name);
            }
          }
        });
        setLocalFilters(prev => _.isEqual(prev, tempLocalIncidentsQuestions) ? prev : { ...tempLocalIncidentsQuestions });
        if (tempIncidentsQuestions.length > 0) {
          tempFilters["Questions"] = tempIncidentsQuestions;
        }
        if (searchQuery) {
          tempFilters["Description"] = `${searchQuery}*`;
          tempDisplayFilters["Description"] = `Поиск: ${searchQuery}*`
        }
        setFilters(prev => {
          const merged = { ...prev, ...tempFilters };
          return _.isEqual(prev, merged) ? prev : merged;
        });
        setDisplayFilters(prev => {
          const merged = { ...prev, ...tempDisplayFilters };
          return _.isEqual(prev, merged) ? prev : merged;
        });
        const tempFiltersParamsForIncidents = { ...existsFiltersIncidents };
        if (!_.isEqual(filtersParams, tempFiltersParamsForIncidents)) {
          setFiltersParams({ ...tempFiltersParamsForIncidents });
        }
        setGegIncidents(false);
      }
    }
  }, [incidentsFilter, incKeys]);

  return (
    <FlexCol className="relative filters-date-no-remove">
      <Form
        key={`${reRenderUserFilter ?? 0}-${JSON.stringify(defaultValues)}`}
        type="filter_my_tasks_inc"
        setFormData={setIncidentsFilter}
        fieldsForm={[...fields]}
        setCurrentTypeInc={setCurrentTypeInc}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {incidentsFilter && Object.keys(incidentsFilter).length > 0 && (
        <div
          onClick={handleResetAllFilters}
          className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
        >
          <div className="flex flex-col group-hover:underline">
              Сбросить фильтры</div>
          <div className="flex flex-col pt-1">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_33_4954)">
                <path
                  d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                  fill="#637381"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_33_4954">
                  <rect
                    width="12"
                    height="12"
                    fill="white"
                    transform="translate(0 12) rotate(-90)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      )}
    </FlexCol>
  );
}
